import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/vercel/path0/app/(founder)/auth/login/_components/login-form.tsx");
